module.exports = __webpack_public_path__ + "static/las-vegas-e664b2ee93d544cf12a3d7e737b8dfae.png";